<template>

    <div class="classificationPlanReview">

        <main role="main">

            <div class="container">

                <div class="row mb-5">

                    <div class="col-md-12">

                        <h2 class="mb-5">
                            {{$t('text.classificationPlanReview.title')}}
                        </h2>
                        <ClassificationPlanFilter :modalName="modalName1" :id="filterKey2" :key="filterKey2"/>

                        <b-modal
                                centered
                                id="modal-export"
                                size="lg"
                                :title="$t('text.classificationPlanReview.classificationPlanExportModal.title')"
                        >
                                <b-row class="bg-light">
                                    <b-col>
                                        <ClassificationPlanFilter :modalName="modalName2" :toExport="true" :id="filterKey1" :key="filterKey1"/>
                                    </b-col>
                                </b-row>
                            <div  slot="modal-footer" class="w-100" >
                                <b-button id="cancelButton1" class="float-left"  variant="secondary" @click="$bvModal.hide('modal-export')">{{$t('text.globals.cancel')}}</b-button>
                                <b-button id="exportButton1" class="float-right mr-0" variant="primary" @click="() => {$bvModal.hide('modal-export'); exportClassificationPlan(); updateClassificationPlan()}">{{$t('text.globals.export')}}</b-button>
                            </div>
                        </b-modal>

                        <b-modal
                                centered
                                id="modal-print"
                                :title="$t('text.classificationPlanReview.classificationPlanPrintModal.title')"
                                size="lg"
                        >
                                <b-row class="bg-light">
                                    <b-col>
                                        <ClassificationPlanFilter :toPrint="true" :id="filterKey3" :key="filterKey3"/>
                                    </b-col>
                                </b-row>

                            <div  slot="modal-footer" class="w-100" >
                                <b-button id="cancelButton2" class="float-left"  variant="secondary" @click="$bvModal.hide('modal-print')">{{$t('text.globals.cancel')}}</b-button>
                                <b-button id="printButton1" class="float-right mr-0" variant="primary" @click="() => {printClassificationPlan();$bvModal.hide('modal-print')}">{{$t('text.globals.print')}}</b-button>
                            </div>

                        </b-modal>


                        <div class="row">
                            <div class="col-md-6 text-left">

                                <router-link to="/ClassificationPlan" class="btn btn-secondary" @click="">{{$t('text.globals.cancel')}}</router-link>

                            </div>
                            <div class="col-md-6 text-right">

                                <button id="exportButton2" v-if="classificationPlan.length > 0 && $globalFunctions.checkForPermission('UVOZ_IZVOZ_KLASIF')" class="btn btn-primary"
                                        @click="$bvModal.show('modal-export')"
                                        v-b-tooltip.hover :title="$t('text.classificationPlanReview.exportButton.tooltip')"><i
                                        class="fas fa-file-download"></i> {{$t('text.globals.export')}}
                                </button>
                                <button id="printButton2" v-if="classificationPlan.length > 0 && $globalFunctions.checkForPermission('TISKANJE_KLASIF')" class="btn btn-primary" @click="$bvModal.show('modal-print')"
                                        v-b-tooltip.hover
                                        :title="$t('text.classificationPlanReview.printButton.tooltip')"><i
                                        class="fas fa-print"></i> {{ $t("text.classificationPlanReview.printButton.label") }}
                                </button>

                            </div>
                        </div>





                    </div>
                </div>
            </div>


        </main>

    </div>

</template>

<script>

    import SidebarNavigation from '../components/SidebarNavigation'
    import VueSelect from 'vue-select';
    import TreeStructure from '../components/TreeStructure'
    import 'vue-select/dist/vue-select.css';
    import ClassificationPlanFilter from '../components/ClassificationPlanFilter';
    import convert from 'xml-js';
    import flatten from 'flat';
    import axios from "axios/index";

    export default {
        name: "ClassificationPlanReview",
        components: {
            SidebarNavigation,
            VueSelect,
            TreeStructure,
            ClassificationPlanFilter
        },

        constants: {

        },

        data() {
            return {
                classificationPlan: this.$store.getters.getClassificationPlan,
                filterKey1: 0,
                filterKey2: 1,
                filterKey3: 2,
                modalName1: "modal1",
                modalName2: "modal2"
            }

        },

        watch: {



        },

        mounted() {

            this.$root.$on('changeThis', item => {
                console.log("caught changeThis, item", item);
                this.changeThis(item);
            });

            this.$root.$on("updateFilter", key => {
                console.log("update filter", key);
                if(key === this.filterKey1) {
                    this.filterKey2++;
                    this.filterKey3++
                }

                if(key === this.filterKey2) {
                    this.filterKey1++;
                    this.filterKey3++;
                }

                else {
                    this.filterKey1++;
                    this.filterKey2++;
                }
            })

        },
        beforeDestroy() {

            this.$root.$off('changeThis');

            console.log('destroy');

        },


        methods: {

            updateFilterKeys() {
                this.filterKey1 ++;
                this.filterKey2 ++;
            },

            updateClassificationPlan() {
                console.log("updateClassificationPlan", this.classificationPlan);
                this.$store.dispatch("setClassificationPlan", this.classificationPlan);

            },

            exportClassificationPlan() {
                console.log("EXPORT PLAN");
                let currentClassificationPlan = _.cloneDeep(this.$store.getters.getClassificationPlanFiltered);

                // odstranimo razrede, ki niso označeni
                currentClassificationPlan = this.checkClassificationPlanForExport();

                console.log(currentClassificationPlan);

                // ker se array kot root element ne bo pravilno sparsal v xml, moramo okoli njega dodati root objekt
                let classificationPlanPlusRoot = {
                    root: {
                        classificationPlan: currentClassificationPlan
                    }
                };

                // options za pretvarjanje js2xml
                const options = {compact: true, spaces: 4};

                // pretvorimo objekt v xml
                let classificationPlanXML = convert.js2xml(classificationPlanPlusRoot, options);
                console.log(classificationPlanXML);

                // prenos klasifikacijskega načrta v obliki xml
                this.downloadClassificationPlan(classificationPlanXML, "Klasifikacijski Načrt");

                this.$store.dispatch("setFilters",{label: "none", labelName: "none", povezaniSistemi: "none", rokHrambe: "none",
                    vrstaGradiva: "none", vpisnik: "none", creationDate: "none", usageEndDate: "none"});
                this.$store.dispatch("setClassificationPlanFiltered",[]);
                this.$store.dispatch("setClassificationPlanFilteredAndChecked",[]);
                this.updateFilterKeys();

            },

            checkClassificationPlanForExport() {
                console.log("CHECKING CLASSIFICATION PLAN FOR MARKED CLASSES TO EXPORT");
                let classificationPlan = JSON.parse(JSON.stringify(this.$store.getters.getClassificationPlanFiltered));
                for (let i = classificationPlan.length - 1; i >= 0; i--) {
                    if (classificationPlan[i].structure.checked !== true) {
                        classificationPlan.splice(i, 1);
                    } else {
                        classificationPlan[i] = this.checkClassificationPlanForExportRec(classificationPlan[i]);
                    }

                }
                return classificationPlan;

            },

            checkClassificationPlanForExportRec(classificationPlan) {


                for (let i = classificationPlan.item.length - 1; i >= 0; i--) {

                    if (classificationPlan.item[i].structure.checked !== true) {
                        classificationPlan.item.splice(i, 1);
                    } else {

                        classificationPlan.item[i] = this.checkClassificationPlanForExportRec(classificationPlan.item[i]);
                    }

                }

                delete classificationPlan["structure"];
                delete classificationPlan["errors"];
                return classificationPlan;
            },

            // ustvari blob, mu pripne klasifikacijski nacrt v obliki xml in ga prenese
            downloadClassificationPlan(data, fileName) {

                const blob = new Blob([data], {type: 'text/xml; charset=UTF-8', encoding: 'UTF-8'});
                const url = window.URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.setAttribute('download', fileName + ".xml");
                a.setAttribute('hidden', '');
                a.setAttribute('href', url);

                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                this.updateClassificationPlan();

            },
            checkAll(check) {
                let classificationPlan = this.$store.getters.getClassificationPlanFiltered;
                for(let i = 0; i < classificationPlan.length; i ++) {
                    classificationPlan[i] = this.checkAllRec(classificationPlan[i], check);

                }
                this.updateClassificationPlan();

            },


            checkAllRec(classificationPlan, check) {
                console.log(classificationPlan);
                classificationPlan.structure.checked = check;
                for(let i = 0; i < classificationPlan.item.length; i ++) {
                    classificationPlan.item[i] = this.checkAllRec(classificationPlan.item[i], check);
                }

                return classificationPlan;

            },

            changeThis(item) {
                let initialChecked = item.structure.checked;
                console.log("change this", item);
                let classificationPlan = this.$store.getters.getClassificationPlanFiltered;
                let array = [];
                for (let i = 0; i < classificationPlan.length; i++) {
                    classificationPlan[i] = this.changeThisRec(item, classificationPlan[i]);

                }
                if (initialChecked === false) {
                    classificationPlan = this.changeThisParent(item, classificationPlan);
                }


                this.updateClassificationPlan();
            },

            changeThisRec(item, classificationPlan) {
                if (classificationPlan.classificationLabel === item.classificationLabel) {
                    let value = classificationPlan.structure.checked;
                    value = !value;
                    classificationPlan.structure.checked = value;
                    classificationPlan = this.changeThisChildren(classificationPlan, value);
                    return classificationPlan;
                } else {
                    for (let i = 0; i < classificationPlan.item.length; i++) {
                        classificationPlan.item[i] = this.changeThisRec(item, classificationPlan.item[i]);
                    }
                }
                return classificationPlan;

            },

            changeThisChildren(classificationPlan, value) {
                for (let i = 0; i < classificationPlan.item.length; i++) {
                    classificationPlan.item[i] = this.changeChildrenRec(classificationPlan.item[i], value);
                }
                return classificationPlan;
            },

            changeChildrenRec(classificationPlan, value) {
                console.log("changing children to value ", value,  classificationPlan.classificationLabel);
                classificationPlan.structure.checked = value;
                for (let i = 0; i < classificationPlan.item.length; i++) {
                    classificationPlan.item[i] = this.changeChildrenRec(classificationPlan.item[i], value);
                }

                return classificationPlan;
            },

            changeThisParent(item, classificationPlan) {
                console.log("change parent, item", item);
                if (item.parentClass === "") {
                    console.log("pridemo v none");
                    return classificationPlan;
                }
                for (let i = 0; i < classificationPlan.length; i++) {
                    let array = this.changeThisParentRec(item, classificationPlan[i]);
                    classificationPlan[i] = array[0];
                    if (array[1] === true) {
                        console.log("return ", classificationPlan);
                        return classificationPlan;
                    }
                }
                console.log("return ", classificationPlan);
                return classificationPlan;
            },

            changeThisParentRec(item, classificationPlan) {
                if (classificationPlan.classificationLabel === item.parentClass) {
                    classificationPlan.structure.checked = true;
                    let array = [classificationPlan, true];
                    console.log("return ", array[0].classificationLabel);
                    return array;
                } else {
                    for (let i = 0; i < classificationPlan.item.length; i++) {
                        let array = this.changeThisParentRec(item, classificationPlan.item[i]);
                        if (array[1] === true) {
                            classificationPlan.structure.checked = true;
                            console.log("return", array[0].classificationLabel);
                            classificationPlan.item[i] = array[0];
                            array[0] = classificationPlan;
                            return array;
                        }
                        classificationPlan.item[i] = array[0];
                    }
                    let array1 = [classificationPlan, false];
                    console.log("return ", array1[0].classificationLabel);
                    return array1;
                }
            },

            printClassificationPlan() {
                const _this = this;
                let classificationPlan = this.checkClassificationPlanForExport();
                // console.log(classificationPlan);
                this.$store.dispatch("setClassificationPlanFilteredAndChecked", classificationPlan);
                //this.$router.push({name: 'ClassificationPlanPrint', params: {from: "classificationPlanReview"}});

                if (classificationPlan.length === 0) {
                    _this.$bvModal.hide("modal-print");

                    _this.$swal(
                        this.$t('text.globals.error'),
                        this.$t(
                            "text.classificationPlan.printExportEmptyClassificationPlanErrorSwal.content"
                        ),
                        "error",
                        {dangerMode: true}
                    );
                    return;
                }

                _this.isLoading = true;

                let knIds = [];
                let temp = flatten(classificationPlan);

                _.map(temp, function (val, key) {
                    let nameArr = key.split('.');
                    _.map(nameArr, function (_val, _key) {
                        if (_val === 'classificationLabel') {
                            knIds.push(val);
                        }
                    });
                });

                let data = {
                    knIds: knIds
                };

                let explanations = [];
                _.each( this.$store.getters.getFilters, function(filter,key,idx,i) {
                  console.log(filter, key, idx,i);
                  if(key !== 'creationDate' && key !== 'usageEndDate') {
                    explanations.push({"operator": "", "parameter": key, "value": filter && filter !== 'none' ? filter : null});
                  } else {
                    explanations.push({"operator": "", "parameter": key + 'Start', "value": filter.start && filter.start !== 'none' ? filter.start : null});
                    explanations.push({"operator": "", "parameter": key + 'End', "value": filter.end && filter.end !== 'none' ? filter.end : null});
                  }
                });
                data.explanations = explanations;


              axios
                    .post(config.reports + "printClassificationPlan", data, {
                        responseType: "blob"
                    })
                    .then(res => {
                        const url = window.URL.createObjectURL(
                            _this.blobToFile(res.data, "Klasifikacijski_nacrt")
                        );
                        const link = document.createElement("a");

                        link.href = url;
                        link.setAttribute("download", "klasifikacijski_nacrt.pdf");
                        link.setAttribute("type", "application/pdf");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        _this.isLoading = false;

                        _this.$store.dispatch("setFilters",{label: "none", labelName: "none", povezaniSistemi: "none", rokHrambe: "none",
                            vrstaGradiva: "none", vpisnik: "none", creationDate: "none", usageEndDate: "none"});
                        _this.$store.dispatch("setClassificationPlanFiltered",[]);
                        _this.$store.dispatch("setClassificationPlanFilteredAndChecked",[]);
                        _this.updateFilterKeys();

                    })
                    .catch(error => {
                        _this.isLoading = false;
                        console.error(error);
                    });

            },

            blobToFile(theBlob, fileName) {
                theBlob.lastModifiedDate = new Date();
                theBlob.name = fileName;
                return theBlob;
            },

        },

    }
</script>



// WEBPACK FOOTER //
// src/pages/ClassificationPlanReview.vue